import React, { useContext,useState } from 'react';
import ProductLev2 from './ProductLev2';
import SimpleContext from './../../context/SimpleContext';
import SabadKharidDrawer from './../../products/SabadKharidDrawer/SabadKharidDrawer';
import { useHistory } from 'react-router';

const ProductsLev2 = () => {

    const context = useContext(SimpleContext);
    const [modalShow, setModalShow] = useState(false); 
    const history = useHistory();
    
    return ( 
        <div className="products">

            <div className="otherPagesHeader">
                <div className="barbuttonn">
                    <img src="images/Api.png" className="apiLogoHeaders" alt=""/>
                </div>
                <div className="headersNames">
                    <p style={{margin:"0"}}>{context.productNameHeader}</p>
                </div>
                <div className="searchbtnn" onClick={()=>history.go(-1)}>
                    <i className="fa fa-chevron-left" />
                </div>
            </div>
            
            <div className='productHolder'>
                {
                    context.productsLevel2.length ? 
                    context.productsLevel2.map((product,i) =>
                        <div key={i}>
                            <ProductLev2 
                            name = {product.name}
                            price = {product.price}
                            userPrice = {product.user_price}
                            slug = {product.slug}
                            min = {product.minimum}
                            max = {product.maximum}
                            proid = {product.brandID}
                            isSahmiyeh = {product.sahmie_bandi}
                            isvalid = {product.status}
                            numUnit = {product.number_in_unit}
                            numSale = {product.number_in_sale}
                            unit = {product.unit}
                            stock={product.stock}
                            category={product.category}
                            ulImg={product.ULImg}
                            dlImg={product.DLImg}
                            urImg={product.URImg}
                            drImg={product.DRImg}
                            mojud={product.FreshStatus}
                            goodsRef={product.goods_ref}
                            uniqueid={product.unique_id}
                            Role={product.Role}
                            /> 
                        </div>
                    ):null
                }
            </div> 
            <div className="SabadDrawer" >
                <SabadKharidDrawer/>
            </div>
        </div>
     );
}
 
export default ProductsLev2;